/* [EZ] Blog Carousel — blog-tab switching (only relevant when 2+ blogs are added).
   Each panel holds its own ez-carousel (auto-initialised by ez-carousel.js); on tab
   change we show the panel and re-render its carousel so the track/progress measure
   correctly. With a single blog there are no tabs and this just no-ops. */
(function () {
  'use strict';

  class EZBlogCarousel extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.ez-bc__tab'));
      this.panels = Array.from(this.querySelectorAll('.ez-bc__panel'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab));
      });
    }

    select(id) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
      this.panels.forEach((p) => {
        const on = p.dataset.panel === id;
        p.classList.toggle('is-active', on);
        if (on) {
          const car = p.querySelector('[data-ez-carousel]');
          if (car && car.__ezCarousel) {
            car.__ezCarousel.index = 0;
            car.__ezCarousel.render();
          }
        }
      });
    }
  }

  if (!customElements.get('ez-blog-carousel')) {
    customElements.define('ez-blog-carousel', EZBlogCarousel);
  }
})();
